module.exports = __webpack_public_path__ + "img/emoji-tearsofjoy-80x80.88f956e2.png";